module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8011.48ae0764.png";